var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.33333H16V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V7.33333ZM8 14.6667V10H6.66667V14.6667H8ZM10.6667 14.6667V10H9.33333V14.6667H10.6667ZM13.3333 14.6667V10H12V14.6667H13.3333ZM17.3333 4.66667C17.7015 4.66667 18 4.96514 18 5.33333C18 5.70152 17.7015 6 17.3333 6H2.66667C2.29848 6 2 5.70152 2 5.33333C2 4.96514 2.29848 4.66667 2.66667 4.66667H6.66667V2.66667C6.66667 2.29848 6.96514 2 7.33333 2H12.6667C13.0349 2 13.3333 2.29848 13.3333 2.66667V4.66667H17.3333ZM8 3.33333V4.66667H12V3.33333H8Z",
    fill: "#717171"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconGray);
export default __webpack_public_path__ + "static/media/trash-icon-gray.02086dabba0dfd8452fdd4495483e8fa.svg";
export { ForwardRef as ReactComponent };